import { ReactElement } from 'react';
import { LambdaFunctionConfig } from '@localstack/types';
import omit from 'lodash/omit';

import { MagicDetails } from '../../../magic/MagicDetails';

export type LambdaDetailsProps = {
  lambdaFunction: Optional<LambdaFunctionConfig>;
  showCapacityProviderField?: boolean;
};

const SCHEMA = {
  shapes: {
    LambdaFunctionRefactored: {
      type: 'structure',
      members: {
        FunctionName: {
          type: 'string',
        },
        FunctionArn: {
          type: 'string',
        },
        Role: {
          type: 'string',
        },
        Timeout: {
          type: 'integer',
        },
        LastModified: {
          type: 'timestamp',
        },
        Version: {
          type: 'string',
        },
        RevisionId: {
          type: 'string',
        },
        State: {
          type: 'string',
        },
        LastUpdateStatus: {
          type: 'string',
        },
        PackageType: {
          type: 'string',
        },
        Architectures: {
          type: 'string',
        },
        CapacityProviderConfig: {
          type: 'structure',
          members: {
            LambdaManagedInstancesCapacityProviderConfig: {
              type: 'structure',
              members: {
                CapacityProviderArn: { type: 'string' },
                PerExecutionEnvironmentMaxConcurrency: { type: 'string' },
                ExecutionEnvironmentMemoryGiBPerVCpu: { type: 'string' },
              },
            },
          },
        },
      },
    },
  },
};

const getSchema = (schema: typeof SCHEMA, { showCapacityProviderField }: { showCapacityProviderField: boolean }) =>
  showCapacityProviderField ? schema : omit(schema, 'shapes.LambdaFunctionRefactored.members.CapacityProviderConfig');

export const LambdaDetails = ({
  lambdaFunction,
  showCapacityProviderField = false,
}: LambdaDetailsProps): ReactElement => (
  <MagicDetails
    data={lambdaFunction}
    schema={getSchema(SCHEMA, { showCapacityProviderField })}
    entry="LambdaFunctionRefactored"
    title="Details for Lambda"
  />
);
